import React from "react";
import MainInput from "components/MainApp/atoms/Forms/MainInput";
import MainButtonInput from "components/MainApp/atoms/Forms/MainButtonInput";
import DragAndDropImage from "components/MainApp/atoms/Forms/DragAndDropImage";
import MultiSelectGeneric from "components/MainApp/atoms/Forms/MultiSelectInputGeneric";
import styles from "./UserForm.module.scss";
import i18n from "i18n";
import { capitalize } from "helpers/utils/utils_general";

const UserForm = ({
  user,
  handleSelectRole,
  handleChange,
  handleSelectImage,
  handleDeleteImage,
  handleSubmit,
  errors,
  continueEnabled,
  mode,
  businesses,
  selectedBusinesses,
  roles,
  selectedRole,
  handleChangeBusiness,
  handleChangeNodes,
  handleAddBusiness
}) => {
  return (
    <div className={styles["user-form-content"]}>
      <h1 className={styles["user-form-title"]}>{i18n.t("enter.data")}</h1>
      <div className={styles["user-form-field"]} data-automation-id="input-username">
        <MainInput
          label={capitalize(i18n.t("name"))}
          required={true}
          id={"user-username"}
          name="username"
          value={user ? user.username : ""}
          handleChange={handleChange}
          maxLength={100}
          error={errors?.username && errors.username}
        />
      </div>
      {/* {(mode !== 'edit') && <div
                className="user-form-field" data-automation-id="input-password">
                <MainInput
                    label={capitalize(i18n.t("password"))}
                    required={true}
                    type={'password'}
                    id={"user-password"}
                    name="password"
                    value={user ? user.password : ''}
                    handleChange={handleChange}
                    maxLength={100}
                    error={errors?.password && errors.password}
                /></div>} */}

      <div className={styles["user-form-field"]} data-automation-id="input-email">
        <MainInput
          label={capitalize(i18n.t("email"))}
          required={true}
          id={"user-email"}
          name="email"
          value={user ? user.email : ""}
          handleChange={handleChange}
          maxLength={100}
          error={errors?.email && errors.email}
          {...(mode === "edit" && { disabled: true })}
        />
      </div>

      <div className={styles["user-form-field"]} data-automation-id="input-roles">
        <MultiSelectGeneric
          id="roles"
          items={roles}
          required={true}
          label={capitalize(i18n.t("roles"))}
          selected={selectedRole}
          multiple={false}
          handleChange={handleSelectRole}
          error={errors?.roles_id && errors.roles_id}
        />
      </div>

      <h1 className={styles["user-form-title"]}>{i18n.t("associated.companies.branches")}</h1>

      {/* {selectedBusinesses.map((sb, index) => {
        return (
          <div key={sb.id} className="user-form-field">
            <div
              className="user-form-field"
              data-automation-id="input-business"
            >
              <MultiSelectGeneric
                items={businesses}
                required={true}
                label={capitalize(i18n.t("business"))}
                selected={sb.business}
                multiple={false}
                handleChange={(e) => handleChangeBusiness(e, index)}
              />
            </div>

            <div className="user-form-field" data-automation-id="input-nodes">
              <MultiSelectGeneric
                items={sb.nodes}
                required={true}
                label={capitalize(i18n.t("branch.offices"))}
                selected={sb.selectedNodes}
                multiple={true}
                handleChange={(e) => handleChangeNodes(e, index)}
              />
            </div>
          </div>
        );
      })}

      <div className="add-business-button" onClick={handleAddBusiness}>
        Agregar empresa y sucursales
      </div> */}

      <div key={selectedBusinesses[0].id} className={styles["user-form-field"]}>
        <div className={styles["user-form-field"]} data-automation-id="input-business">
          <MultiSelectGeneric
            id="business"
            items={businesses}
            required={true}
            label={i18n.t("business")}
            selected={selectedBusinesses[0].business}
            multiple={false}
            handleChange={e => handleChangeBusiness(e, 0)}
            error={errors?.business && errors.business}
          />
        </div>

        <div className={styles["user-form-field"]} data-automation-id="input-nodes">
          <MultiSelectGeneric
            id="nodes"
            items={selectedBusinesses[0].nodes}
            required={true}
            label={i18n.t("branch.offices")}
            selected={selectedBusinesses[0].selectedNodes}
            multiple={true}
            handleChange={e => handleChangeNodes(e, 0)}
            error={errors?.nodes && errors.nodes}
          />
        </div>
      </div>

      {/* <div className="user-form-field image" data-automation-id="input-image">
        <DragAndDropImage
          name="image"
          isSmall={true}
          handleChange={handleSelectImage}
          handleDelete={handleDeleteImage}
          file={user?.image}
          error={errors?.image && errors.image}
        />
      </div> */}

      <div className={styles["user-form-submit"]}>
        <div
          className={
            styles["user-form-submit-button"]
            + (mode === "edit" ? ' ' + styles["edit"] : "")
            + (continueEnabled ? ' ' + styles["enabled"] : "")
          }
          onClick={continueEnabled ? e => handleSubmit(e) : null}
        >
          {mode === "edit" ? i18n.t("save").toUpperCase(): i18n.t("register.user")}
        </div>
      </div>
    </div>
  );
};

export default UserForm;
